import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useAutoLogout = (triggerLogoutModal, setSession) => {
    const navigate = useNavigate();

    useEffect(() => {
        const expiry = localStorage.getItem('sessionExpiry');
        if (!expiry) return;

        const timeLeft = parseInt(expiry, 10) - Date.now();

        if (timeLeft <= 0) {
            triggerLogoutModal(true);
            setSession(true)
        } else {
            const timeout = setTimeout(() => {
                triggerLogoutModal(true);
                setSession(true)
            }, timeLeft);

            return () => clearTimeout(timeout);
        }
    }, []);
};

export default useAutoLogout;
